import { useEffect, useRef } from "react";
import style from "./Checkbox.module.css";

export interface CheckboxProps {
    value?: boolean;
    onChange?: (value: boolean) => void;

    disabled?: boolean;
    readonly?: boolean;

    // relevant for forms, using the 'for' attribute on labels, etc:
    id?: string;
    name?: string;
    tabIndex?: number;
}


export default function Checkbox(props: CheckboxProps) {
  const {
    value,
    onChange,
    disabled,
    readonly,
    id,
    name,
    tabIndex = undefined,
    ...rest
  } = props;

  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current?.parentElement.tagName === 'LABEL') {
      ref.current.parentElement.style.cursor = 'pointer';
    }
  }, [ref.current]);

  return (
    <input
      {...rest}
      id={id}
      name={name}
      className={style.checkbox}
      tabIndex={tabIndex}
      type="checkbox"
      checked={value}
      disabled={disabled}
      readOnly={readonly}
      ref={ref}
      onChange={(e) => onChange?.(e.target.checked)}
    />
  );
}
